<template>
  <div>
    <div id="reply-fb-post">
      <v-layout>
        <v-flex fill-height style="position: relative; max-width: 25%">
          <ReplyCommentSearchPost
            v-if="facebookPostList"
            v-model="facebookPostList"
            @selectedPost="onSelectedPost"
            :isAgentPerformance="false"
          ></ReplyCommentSearchPost>
          <ReplyCommentSearchBox
            @onsearch="OnSearch"
            @onclearsearch="onClearSearch"
          ></ReplyCommentSearchBox>
          <ReplyCommentTab
            :isCurrentBotType="isBotreply"
            @setCommentType="onSetCommentType"
            @onRefresh="getUserThreadWithPost"
          ></ReplyCommentTab>
          <v-divider></v-divider>
          <ReplyCommentUsers
            :loadingUser="loadingUser"
            v-model="commentList"
            @onSelectedUser="onSelectedUser"
          ></ReplyCommentUsers>
        </v-flex>
        <v-flex
          style="
            border-left: 1px solid #eee;
            border-right: 1px solid #eee;
            position: relative;
            max-width: 45%;
          "
          fill-height
        >
          <ReplyCommentBox
            v-if="selectedComment"
            v-model="chatlog"
            :isMobile="isMobile"
            :selectedUser="selectedComment"
          ></ReplyCommentBox>
        </v-flex>
        <v-flex style="position: relative; max-width: 30%" fill-height>
          <ReplyCommentTool
            v-if="selectedComment"
            v-model="selectedComment"
            :pageid="selectedBot.pageid"
          ></ReplyCommentTool>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import ReplyCommentFBPost from './ReplyCommentFBPost.js'
export default {
  mixins: [ReplyCommentFBPost]
}
</script>
<style>
.newnotifycount {
  line-height: 16px;
  border-radius: 15px;
  position: absolute;
  right: 3px;
  top: 5px;
  padding-left: 3px;
  padding-right: 3px;
  background-color: #ff6565;

  font-size: 10px;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/RabbitReplyFBPost/ReplyCommentView.vue